import { ValidationError } from './projects/validation.models';
import { PtLuxonDate } from './projects/date.models';
import { DateTime } from 'luxon';

export class CompleteDayEditor {
  ptLuxonDate: PtLuxonDate;
  isComplete: boolean;
  isSignedOff: boolean;
  // used in locked day navigator
  validationErrors: ValidationError[] = [];
  errorsJson: string;
  errorCount: number;
  warningCount: number;
  isDefault: boolean; // only used in initial app setup, if the app is setup in a negative offset - needed for implementer-initialiser component
  localDate: Date; // local only, used in implementer-navigator
}

export class CompleteDayFilters {
  date?: DateTime;
  id?: number;
}

export class CompleteDaySummary {
  date: Date;
}




// WEBPACK FOOTER //
// ./src/models/complete-day.models.ts